import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useRef,
} from "react";
import { withTranslation } from "react-i18next";
import * as moment from "moment";
import { encodeId } from "utils";
import { findKey } from "lodash";
import constants from "../../../../../../../constants.js";
import defautUserImage from "assets/images/staff-default.svg";
import HolidayImage from "assets/images/early_on.svg";
import Loader from "components/Loader";
import toast from "react-hot-toast";
import Empty from "components/Empty";
import {
  filterEventsBySearch,
  filteringMethodForEventShiftOthers,
  leaveClasses,
} from "accountOwner/pages/Scheduler/scheduler.function";
import {
  renderOfficeNameOrEnterprise,
  setterCustomSchduler,
  setterPublishOffices,
  matchedBothPatternValues,
  matchedBothDatesValues,
} from "accountOwner/pages/AddEvent/addEvents.functions";
import { addEditEventsConst } from "accountOwner/pages/AddEvent/addEvents.constants";
import EditOptionsModal, {
  editTypesVariables,
} from "accountOwner/pages/EditEvent/EditOptionsModal";
import styles from "../../../../../AddEvent/AddEvent.module.scss";
import schedulerStyles from "../../../../Scheduler.module.scss";
import staffAvailabilityStyles from "../StaffAvailabilityTab.module.scss";
import { Tooltip, Col, Row } from "reactstrap";
import { useHistory } from "react-router-dom";
import { useAccountOwnerCommon } from "lib/Context/AccountOwner";
import Text from "components/Text";
import {
  useGetOfficeAgenda,
  updateBusySlot,
  useCreateUpdateSchedulerEventMutation,
  getEventListDetails,
  getBusySlot,
} from "repositories/scheduler-repository";
import { useQueryClient } from "react-query";
import { getOfficeDetail } from "repositories/office-repository";
import { useParams } from "react-router-dom/cjs/react-router-dom.min.js";

const HOUR_CELL_HEIGHT_PX = 60;
const MIN_EVENT_HEIGHT_PX = 8;
const DEFAULT_DARK_COLOR = "#2D3245";
const OWNER_COLOR = "#8c0346";
const POPUP_WIDTH = 380;

const getOfficeColor = (user, selectedOwnerId) => {
  if (user?.id === selectedOwnerId) {
    return OWNER_COLOR;
  }

  const officeColor = user?.officeColourCodes;

  if (!officeColor) {
    return DEFAULT_DARK_COLOR;
  }

  return officeColor;
};

function DailyListView({
  t,
  currentDate,
  selectedOwnerId,
  currentUserId,
  apiOffices = [],
  apiEmps = [],
  agendaTypes = [],
  cachedEventFilter =[],
  viewSettingFilter =[],
  searchValue = "",
  isEnterpriseFilterActive = false,
  isFreeStotLoading = false,
  canShowOfficeName = true,
  context,
  selectedStaff,
  showFreeSlots,
  onFreeSlotClick,
  onTimeLabelClick,
  selectedHourIdx,
  startTime,
  findAvailabilityData,
  resetFocusRef,
  focusOnFirstAvailableSlot,
}) {
  const isSchedulingAssistant = useMemo(
    () => context === "scheduling-assistant",[],
  );

  const { eventId: eventIdFromUrl } = useParams();
  const [dateRange, setDateRange] = useState(null);
  const[agendaFilter, setAgendaFilter] = useState([]);
  const [openTooltipId, setOpenTooltipId] = useState(null);
  const [hoverKey, setHoverKey] = useState("");
  const[clickedEventData, setClickedEventData] = useState(null);
  const [draggedEvent, setDraggedEvent] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const[dragPreviewPosition, setDragPreviewPosition] = useState(null);
  const [editModalConfirmation, setEditModalConfirmation] = useState(false);
  const [pendingDragUpdate, setPendingDragUpdate] = useState(null);
  const[isDragDropLoading, setIsDragDropLoading] = useState(false);

  // State for dynamic table height calculation
  const [tableHeight, setTableHeight] = useState("auto");

  // Ref for the popup container to detect outside clicks
  const popupRef = useRef(null);

  const history = useHistory();
  const { profile, isStaff, isOwner, dataAccessValues, effectiveOwnerIdString } =
    useAccountOwnerCommon();
  const createSchedulerEventMutation = useCreateUpdateSchedulerEventMutation();
  const queryClient = useQueryClient();
  const tableContainerRef = useRef(null);
  const currentHourRowRef = useRef(null);

  // --- START OF DYNAMIC HEIGHT CALCULATION ---
  useEffect(() => {
    const calculateDynamicHeight = () => {
      if (tableContainerRef.current) {
        // Get the distance of the container from the top of the viewport
        const rect = tableContainerRef.current.getBoundingClientRect();
        const viewportHeight = window.innerHeight;

        // Find the specific wrapper based on client instructions:
        // Look for .scheduler-tabs or .Dashboard_box to check boundaries.
        // Fallback to document.body if neither is found.
        const wrapper =
          tableContainerRef.current.closest(".scheduler-tabs") ||
          tableContainerRef.current.closest(".Dashboard_box") ||
          document.body;

        // Default limit is the bottom of the viewport
        let limitBottom = viewportHeight;

        // If the wrapper is found, check if its bottom is visible within the viewport
        if (wrapper) {
          const wrapperRect = wrapper.getBoundingClientRect();
          // If the wrapper's bottom is ABOVE the viewport bottom (meaning we scrolled past it or it's short),
          // use the wrapper's bottom as the limit. This prevents overlap.
          // We subtract a small buffer (5px) to ensure borders aren't cut off.
          if (wrapperRect.bottom < viewportHeight) {
            limitBottom = wrapperRect.bottom - 5;
          }
        }

        // Calculate maxHeight: The distance from the top of the table (rect.top)
        // to the limit (either screen bottom or wrapper bottom).
        // We subtract 20px for the scrollbar itself so it sits comfortably.
        let computedHeight = limitBottom - rect.top - 20;

        // Minimum safety check to prevent it from disappearing
        if (computedHeight < 200) computedHeight = 200;

        setTableHeight(`${computedHeight}px`);
      }
    };

    // Calculate on mount and shortly after (for DOM paint)
    calculateDynamicHeight();
    const timeoutId = setTimeout(calculateDynamicHeight, 100);

    // Attach listeners
    window.addEventListener("resize", calculateDynamicHeight);
    window.addEventListener("scroll", calculateDynamicHeight, {
      passive: true,
    });

    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener("resize", calculateDynamicHeight);
      window.removeEventListener("scroll", calculateDynamicHeight);
    };
  },[]);
  // --- END OF DYNAMIC HEIGHT CALCULATION ---

  useEffect(() => {
    if (clickedEventData && popupRef.current) {
      popupRef.current.scrollIntoView({
        behavior: "smooth",
        block: "nearest", // Ensures vertical alignment
        inline: "nearest", // Ensures horizontal alignment
      });
    }
  }, [clickedEventData]);


  let scrollHour = null;
  if (startTime) {
    scrollHour = moment.isMoment(startTime)
      ? startTime.hour()
      : moment(startTime, ["h:mm A", "HH:mm"]).hour();
  }

  useEffect(() => {
    if (
      startTime &&
      tableContainerRef.current &&
      currentHourRowRef.current &&
      !focusOnFirstAvailableSlot?.current
    ) {
      setTimeout(() => {
        currentHourRowRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }, 500);
    }
  },[agendaFilter, selectedStaff, currentDate, startTime]);

  // Handle Click Outside Logic
  useEffect(() => {
    const handleClickOutside = (event) => {
      // If popup is open, and the click target is NOT inside the popupRef
      if (
        clickedEventData &&
        popupRef.current &&
        !popupRef.current.contains(event.target)
      ) {
        setClickedEventData(null);
        setHoverKey("");
      }
    };

    // Use mousedown to capture the interaction before click completes
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [clickedEventData]);

  const canEditAndViewOthersData = useCallback(
    (officeId) => {
      if (isStaff) {
        return (
          dataAccessValues?.officeList?.some(
            (res) => res.officeId === officeId && res.isAdmin,
          ) || false
        );
      }
      return isOwner;
    },
    [isStaff, isOwner, dataAccessValues?.officeList],
  );

  const toggleTooltip = (id) => {
    setOpenTooltipId((prev) => (prev === id ? null : id));
  };

  const resetHoverKey = useCallback((e) => {
    e?.stopPropagation();
    setHoverKey("");
    setClickedEventData(null);
  },[]);

  // Set date range for single day
  useEffect(() => {
    if (currentDate) {
      setDateRange({
        startDate: moment(currentDate).format("YYYY-MM-DD"),
        endDate: moment(currentDate).format("YYYY-MM-DD"),
      });
    }
  }, [currentDate]);

  // Filter agenda by events
  const filterByEvents = (agendaData) => {
    if (!agendaData) return[];
    const updatedAgenda = agendaData.map((item) => {
      const schedulerList = Array.isArray(item.officeSchedulerList)
        ? item.officeSchedulerList
        :[item.officeSchedulerList];

      const filteredSchedulerList = schedulerList.map((schedulerItem) =>
        filteringMethodForEventShiftOthers(
          agendaTypes,
          schedulerItem,
          currentUserId,
        ),
      );

      return {
        ...item,
        officeSchedulerList: filteredSchedulerList,
      };
    });
    return updatedAgenda;
  };

  // Fetch agenda data
  const enableFetch = Boolean(
    selectedOwnerId && dateRange?.startDate && dateRange?.endDate,
  );

  const {
    isLoading,
    isFetching,
    data: dailyData,
    error,
  } = useGetOfficeAgenda(
    selectedOwnerId,
    dateRange?.startDate,
    dateRange?.endDate,
    apiOffices,
    apiEmps,
    { enabled: enableFetch },
  );

  useEffect(() => {
    if (!isLoading && dailyData?.data) {
      if (cachedEventFilter?.length > 0) {
        setAgendaFilter(filterByEvents(dailyData.data));
      } else if (cachedEventFilter?.length === 0) {
        setAgendaFilter(dailyData.data);
      }
    }
  },[isLoading, dailyData, cachedEventFilter, agendaTypes, currentUserId]);

  useEffect(() => {
    if (!isLoading && !isFetching && error?.message) {
      toast.error(error.message);
    }
  },[error, isLoading, isFetching]);

  // Apply enterprise filter
  let filteredAgendaFilter = agendaFilter;
  if (isEnterpriseFilterActive) {
    filteredAgendaFilter = (agendaFilter ||[]).map((date) => {
      const filteredOfficeSchedulerList = (date.officeSchedulerList ||[]).map(
        (item) => ({
          ...item,
          appointments: (item.appointments ||[]).filter(
            (e) => e && e?.isEnterprise === true,
          ),
          leaves: (item.leaves ||[]).filter(
            (e) => e && e?.isEnterprise === true,
          ),
          schedulerBusySlots: (item.schedulerBusySlots ||[]).filter(
            (e) => e && e?.isEnterprise === true,
          ),
          schedulerEvents: (item.schedulerEvents ||[]).filter(
            (e) => e && e?.isEnterprise === true,
          ),
          appointmentSlots: (item.appointmentSlots ||[]).filter(
            (e) => e && e?.isEnterprise === true,
          ),
        }),
      );
      return {
        ...date,
        officeSchedulerList: filteredOfficeSchedulerList,
      };
    });
  }

  // Generate hours (12 AM to 11 PM - 24 hours)
  const hours = useMemo(() => {
    const hourList =[];
    for (let i = 0; i <= 23; i++) {
      const hour = moment().hour(i).minute(0);
      hourList.push({
        label: hour.format("h A"),
        moment: hour,
        hour: i,
      });
    }
    return hourList;
  },[]);

  // Helper function to get all staff events
  const getAllStaffEvents = useCallback((scheduler) => {
    const events =[];

    // Add scheduler events
    if (scheduler.schedulerEvents) {
      events.push(
        ...scheduler.schedulerEvents.map((event) => ({
          ...event,
          type: "schedulerEvent",
        })),
      );
    }

    // Add appointment slots
    if (scheduler.appointmentSlots) {
      events.push(
        ...scheduler.appointmentSlots.map((slot) => ({
          ...slot,
          type: "appointmentSlot",
          title: slot.reasonForBlock || "Appointment Slot",
        })),
      );
    }

    // Add busy slots
    if (scheduler.schedulerBusySlots) {
      events.push(
        ...scheduler.schedulerBusySlots.map((slot) => ({
          ...slot,
          type: "busySlot",
        })),
      );
    }

    // Add appointments
    if (scheduler.appointments) {
      events.push(
        ...scheduler.appointments.map((appointment) => ({
          ...appointment,
          type: "appointment",
        })),
      );
    }

    // Add leaves
    if (scheduler.leaves) {
      events.push(
        ...scheduler.leaves.map((leave) => ({
          ...leave,
          type: "leave",
          isAllDayEvent: true, // Ensure leaves are treated as all-day events
          title: leave.reason || "Leave",
        })),
      );
    }

    return events;
  },[]);

  // Categorize events into all-day and time-based
  const categorizeEvents = useCallback((events) => {
    return {
      allDayEvents: events.filter(
        (event) =>
          event.isAllDayEvent ||
          event.isAllDayBusy ||
          !event.startTime ||
          !event.endTime ||
          new Date(event.startTime).toDateString() !==
            new Date(event.endTime).toDateString(),
      ),
      timeEvents: events.filter(
        (event) =>
          !event.isAllDayEvent &&
          !event.isAllDayBusy &&
          event.startTime &&
          event.endTime &&
          new Date(event.startTime).toDateString() ===
            new Date(event.endTime).toDateString(),
      ),
    };
  },[]);

  // Get event colors based on type
  const getEventColor = useCallback(
    (event) => {
      if (!event || !event.agendaType) {
        return "#c7e9ff";
      }
      const pendingCheck =
        event?.statusId === constants.agendaType.PENDINGLEAVE;

      switch (event.agendaType) {
        case constants.agendaType.LEAVE:
          return pendingCheck ? "#fdeded" : "rgba(113, 213, 185, 0.2)";
        case constants.agendaType.BUSY_SLOT:
        case constants.agendaType.BLOCKED:
          return "#fef3d7";
        case constants.agendaType.EVENT:
          if (event.eventStatus === constants.SCHEDULERSTATUS.PENDING) {
            return "#e1f4fd";
          } else if (currentUserId === event.createdById) {
            return "#f9fcee";
          } else {
            return "#f2f3ef";
          }
        case constants.agendaType.APPOINTMENT:
          return "#f6f1fd";
        default:
          return "#c7e9ff";
      }
    },
    [currentUserId],
  );

  const getEventBorderColor = useCallback(
    (event) => {
      if (!event || !event.agendaType) {
        return "#005f99";
      }
      const pendingCheck =
        event?.statusId === constants.agendaType.PENDINGLEAVE;
      switch (event.agendaType) {
        case constants.agendaType.LEAVE:
          return pendingCheck ? "#ff5757" : "#71d5b9";
        case constants.agendaType.BUSY_SLOT:
        case constants.agendaType.BLOCKED:
          return "#f7cb7a";
        case constants.agendaType.EVENT:
          if (event.eventStatus === constants.SCHEDULERSTATUS.PENDING) {
            return "#82d8f8";
          } else if (currentUserId === event.createdById) {
            return "#f7cb7a";
          } else {
            return "#707070";
          }
        case constants.agendaType.APPOINTMENT:
          return "#d8b4f8";
        default:
          return "#005f99";
      }
    },
    [currentUserId],
  );

  // Helper function to map background color to CSS class
  const getBackgroundColorClass = useCallback(
    (eventItem) => {
      if (!eventItem || !eventItem.agendaType) {
        return "color-blue";
      }

      const pendingCheck =
        eventItem?.statusId === constants.agendaType.PENDINGLEAVE;

      switch (eventItem.agendaType) {
        case constants.agendaType.LEAVE:
          return pendingCheck ? "red-bg" : "green-bg";
        case constants.agendaType.BUSY_SLOT:
        case constants.agendaType.BLOCKED:
          return "light-orange-bg";
        case constants.agendaType.EVENT:
          if (eventItem.eventStatus === constants.SCHEDULERSTATUS.PENDING) {
            return "color-blue";
          } else if (currentUserId === eventItem.createdById) {
            return "";
          } else {
            return "color-grey";
          }
        case constants.agendaType.APPOINTMENT:
          return "light-purple-bg";
        default:
          return "color-blue";
      }
    },
    [currentUserId],
  );

  // Helper function to map tag/border color to CSS class
  const getTagColorClass = useCallback(
    (eventItem) => {
      if (!eventItem || !eventItem.agendaType) {
        return "theme-green-bg";
      }

      const pendingCheck =
        eventItem?.statusId === constants.agendaType.PENDINGLEAVE;

      switch (eventItem.agendaType) {
        case constants.agendaType.LEAVE:
          return pendingCheck ? "dark-red-bg" : "dark-green-bg";
        case constants.agendaType.BUSY_SLOT:
        case constants.agendaType.BLOCKED:
          return "dark-orange-bg";
        case constants.agendaType.EVENT:
          if (eventItem.eventStatus === constants.SCHEDULERSTATUS.PENDING) {
            return "theme-green-bg";
          } else if (currentUserId === eventItem.createdById) {
            return "theme-green-bg";
          } else {
            return "dark-grey-bg";
          }
        case constants.agendaType.APPOINTMENT:
          return "dark-grey-bg";
        default:
          return "theme-green-bg";
      }
    },
    [currentUserId],
  );

  const handlePopupClick = useCallback(
    (e, event, scheduler, hoverKey) => {
      e.stopPropagation();
      setHoverKey(hoverKey);

      const container = tableContainerRef.current;
      const target = e.currentTarget;

      if (container && target) {
        const containerRect = container.getBoundingClientRect();
        const targetRect = target.getBoundingClientRect();
        const containerWidth = container.clientWidth; // Width of the visible window

        // 1. Calculate relative positions
        const targetLeftRel = targetRect.left - containerRect.left;
        const targetRightRel = targetRect.right - containerRect.left;

        // 2. Determine available space
        const spaceRight = containerWidth - targetRightRel;
        const spaceLeft = targetLeftRel;

        let left = 0;
        const scrollLeft = container.scrollLeft; // Current scroll position

        // 3. Choose Preferred Side
        if (spaceRight >= POPUP_WIDTH) {
          left = targetRightRel + scrollLeft;
        } else if (spaceLeft >= POPUP_WIDTH) {
          left = targetLeftRel + scrollLeft - POPUP_WIDTH;
        } else {
          // If neither fits perfectly, pick the side with MORE space
          if (spaceLeft > spaceRight) {
             left = targetLeftRel + scrollLeft - POPUP_WIDTH;
          } else {
             left = targetRightRel + scrollLeft;
          }
        }

        // 4. PIXEL PERFECT FIX: Clamp the position
        // This forces the popup to stay inside the container's visible bounds
        // Min Left = Current Scroll Position (Left Edge)
        // Max Left = Current Scroll Position + Width - Popup Width (Right Edge)
        const minLeft = scrollLeft;
        const maxLeft = scrollLeft + containerWidth - POPUP_WIDTH;
        
        // Apply Clamp: prevents negative (off-screen left) or overflow (off-screen right)
        left = Math.max(minLeft, Math.min(left, maxLeft));

        // 5. Calculate Top
        let top = targetRect.top - containerRect.top + container.scrollTop - 10;

        setClickedEventData({
          event,
          top,
          left,
          staffName: scheduler.user?.fullName,
          bgColor: getBackgroundColorClass(event),
          tagColor: getTagColorClass(event),
        });
      }
    },
    [getBackgroundColorClass, getTagColorClass],
  );

  // Get popup data
  const getPopupData = useCallback(
    (item, requestedDate) => {
      const data = {};
      data.title = item?.title || item?.reasonForBlock || null;
      data.officeName = renderOfficeNameOrEnterprise(item, t);
      data.patientFullName = item?.patientFullName || null;
      data.startTime = item?.startTime
        ? moment(item.startTime).format("h:mm a")
        : "";
      data.endTime = item?.endTime ? moment(item.endTime).format("h:mm a") : "";
      data.date = moment(requestedDate).format("MMM D, YYYY[-] ddd");
      const { agendaType } = item;
      switch (agendaType) {
        case constants.agendaType.EVENT: {
          const createdByOthers =
            item?.isShift && profile?.id !== item?.createdById;
          if (createdByOthers) {
            data.tag = t("scheduler.agenda.shiftByOthers");
          } else if (item?.isShift) {
            data.tag = t("scheduler.agenda.shiftTag");
          } else {
            data.tag = t("scheduler.agenda.eventTag");
          }
          break;
        }
        case constants.agendaType.BUSY_SLOT: {
          data.tag = t("scheduler.agenda.busyTag");
          break;
        }
        case constants.agendaType.BLOCKED: {
          data.tag = t("scheduler.agenda.busyTag");
          break;
        }
        case constants.agendaType.APPOINTMENT: {
          data.tag = t("scheduler.agenda.appointmentTag");
          data.title = t("scheduler.agenda.patient", {
            name: item.patientFullName,
          });
          data.isAppointment = true;
          const status = findKey(
            constants.appointmentStatus,
            (s) => s === item.appointmentStatus,
          );
          data.appointmentStatus = status
            ? t(`appointmentStatus.${status}`)
            : "--";
          break;
        }
        case constants.agendaType.LEAVE: {
          const { text } = leaveClasses(item?.statusId);
          data.tag = t(text);
          data.title = "";
          data.isLeave = true;
          break;
        }
        default: {
          break;
        }
      }
      return data;
    },
    [t, profile?.id],
  );
  // Get popup view
  const getPopupView = useCallback(
    (item, backgroudColor, tagBackgroundColor, requestedDate, staffName) => {
      const data = getPopupData(item, requestedDate);

      return (
        <div
          className={schedulerStyles["scheduler-popup-box"]}
          style={{
            background: "#ffffff",
            padding: "30px",
            position: "relative",
            boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.083998)",
            borderRadius:"6px",
            maxWidth: POPUP_WIDTH,
          }}
        >
          {/* UPDATED CLOSE ICON with Explicit Styling to Fix Visibility */}
          <span
            className={schedulerStyles["close-icon"]}
            onClick={resetHoverKey}
            style={{
              position: "absolute",
              background: "#f3f3f3",
              right: "5px",
              top: "5px",
              cursor: "pointer",
              borderRadius: "100%",
              width: "27px",
              height: "27px",
              fontSize: "20px",
              lineHeight: "27px",
              textAlign: "center",
              color: "#587e85",
              fontWeight: "200",
              zIndex: 10,
            }}
          >
            &times;
          </span>
          <div
            className={
              schedulerStyles["scheduler-event-box"] +
              (backgroudColor ? " " + schedulerStyles[backgroudColor] : "")
            }
          >
            <div
              className={
                schedulerStyles["event-tag"] +
                " " +
                schedulerStyles[tagBackgroundColor]
              }
            >
              {data.tag}
            </div>
            <div className={schedulerStyles["event-type"]}>{data.title}</div>
            <Row className={schedulerStyles.row}>
              <Col sm="6">
                <Text
                  size="10px"
                  marginBottom="0px"
                  weight="400"
                  color="#87928D"
                >
                  {constants.agendaType.APPOINTMENT === item.agendaType
                    ? t("scheduler.agenda.doctorName")
                    : t("scheduler.agenda.staffName")}
                </Text>
                <Text
                  size="12px"
                  marginBottom="10px"
                  weight="500"
                  color="#2F3245"
                >
                  {staffName}
                </Text>
              </Col>
              <Col sm="6">
                <Text
                  size="10px"
                  marginBottom="0px"
                  weight="400"
                  color="#87928D"
                >
                  {t("accountOwner.officeName")}
                </Text>
                <Text
                  size="12px"
                  marginBottom="10px"
                  weight="500"
                  color="#2F3245"
                >
                  {data.officeName}
                </Text>
              </Col>
              <Col sm="6">
                <Text
                  size="10px"
                  marginBottom="0px"
                  weight="400"
                  color="#87928D"
                >
                  {t("accountOwner.date")}
                </Text>
                <Text
                  size="12px"
                  marginBottom="10px"
                  weight="500"
                  color="#2F3245"
                >
                  {data.date}
                </Text>
              </Col>
              {!data.isLeave && (
                <Col sm="6">
                  <Text
                    size="10px"
                    marginBottom="0px"
                    weight="400"
                    color="#87928D"
                  >
                    {data.isAppointment
                      ? t("timeOfAppointment")
                      : t("staff.startTime")}
                  </Text>
                  <Text
                    size="12px"
                    marginBottom="12px"
                    weight="500"
                    color="#2F3245"
                  >
                    {data.startTime}
                  </Text>
                </Col>
              )}
              {!data.isLeave && (
                <Col sm="6">
                  <Text
                    size="10px"
                    marginBottom="0px"
                    weight="400"
                    color="#87928D"
                  >
                    {data.isAppointment ? t("status") : t("staff.endTime")}
                  </Text>
                  <Text
                    size="12px"
                    marginBottom="12px"
                    weight="500"
                    color="#2F3245"
                  >
                    {data.isAppointment
                      ? data?.appointmentStatus
                      : data.endTime}
                  </Text>
                </Col>
              )}
            </Row>
          </div>
        </div>
      );
    },
    [getPopupData, t, resetHoverKey],
  );

  const isAllDayEvent = useCallback((eventItem) => {
    return (
      eventItem.isAllDayEvent ||
      eventItem.isAllDayBusy ||
      !eventItem.startTime ||
      !eventItem.endTime
    );
  },[]);

  // Get event display text (time and office name)
  const getEventDisplayText = useCallback(
    (event, user = null) => {
      if (!event) return null;

      // Check if event is all-day
      const isAllDay =
        event.isAllDayEvent ||
        event.isAllDayBusy ||
        !event.startTime ||
        !event.endTime;

      if (!viewSettingFilter || viewSettingFilter.length === 0) {
        let eventTitle = event?.title || "";
        if (event?.agendaType === constants.agendaType.LEAVE) {
          eventTitle = "On Leave";
        } else if (event?.agendaType === constants.agendaType.APPOINTMENT) {
          eventTitle = "Patient Appointment";
        }
        if (eventTitle) {
          return (
            <div className="d-flex flex-column">
              <div className={styles["event-office"]}>{eventTitle}</div>
            </div>
          );
        }
        return null;
      }

      let eventTitle = event?.title || "";

      // Override title for Leave and Appointment
      if (event?.agendaType === constants.agendaType.LEAVE) {
        eventTitle = "On Leave";
      } else if (event?.agendaType === constants.agendaType.APPOINTMENT) {
        eventTitle = "Patient Appointment";
      }

      const officeName = renderOfficeNameOrEnterprise(event, t);

      let timeString = "";
      if (isAllDay) {
        timeString = "all-day";
      } else if (event?.startTime && event?.endTime) {
        const startTime = moment(event.startTime).format("h:mm a");
        const endTime = moment(event.endTime).format("h:mm a");
        timeString = `${startTime} - ${endTime}`;
      }

      const displayElements =[];

      if (viewSettingFilter.includes("title") && eventTitle) {
        displayElements.push(
          <div key="title" className={styles["event-office"]}>
            {eventTitle}
          </div>,
        );
      }

      if (
        viewSettingFilter.includes("officeName") &&
        canShowOfficeName &&
        officeName
      ) {
        displayElements.push(
          <div key="officeName" className={styles["event-office"]}>
            {officeName}
          </div>,
        );
      }

      if (viewSettingFilter.includes("timeString") && timeString) {
        displayElements.push(
          <div key="timeString" className={styles["event-office"]}>
            {timeString}
          </div>,
        );
      }

      const hasStaffMembers = viewSettingFilter.includes("staffMembers");
      const hasStaffFirstName = viewSettingFilter.includes("staffFirstName");

      if (hasStaffMembers && hasStaffFirstName && user) {
        const fullName =
          user.fullName ||
          (user.firstName && user.lastName
            ? `${user.firstName} ${user.lastName}`
            : user.firstName || "");
        if (fullName) {
          displayElements.push(
            <div key="staffMembers" className={styles["event-office"]}>
              {fullName}
            </div>,
          );
        }
      } else {
        if (hasStaffMembers && user) {
          const fullName =
            user.fullName ||
            (user.firstName && user.lastName
              ? `${user.firstName} ${user.lastName}`
              : user.firstName || "");
          if (fullName) {
            displayElements.push(
              <div key="staffMembers" className={styles["event-office"]}>
                {fullName}
              </div>,
            );
          }
        }

        if (hasStaffFirstName && user) {
          const firstName = user.firstName || "";
          if (firstName) {
            displayElements.push(
              <div key="staffFirstName" className={styles["event-office"]}>
                {firstName}
              </div>,
            );
          }
        }
      }

      if (displayElements.length === 0) {
        return null;
      }

      return <div className="d-flex flex-column">{displayElements}</div>;
    },
    [t, viewSettingFilter, canShowOfficeName],
  );

  // Helper functions for time-based event positioning
  const getTimeInMinutes = useCallback((time) => {
    if (!time) {
      return 0;
    }
    const date = new Date(time);
    if (Number.isNaN(date.getTime())) {
      return 0;
    }
    const hours = date.getHours();
    const minutes = date.getMinutes();
    return hours * 60 + minutes;
  },[]);

  const calculateOverlapPositions = useCallback(
    (events) => {
      events.sort(
        (a, b) => getTimeInMinutes(a.startTime) - getTimeInMinutes(b.startTime),
      );

      const positions =[];

      for (let i = 0; i < events.length; i++) {
        let overlaps = [events[i]];
        for (let j = i + 1; j < events.length; j++) {
          const endA = getTimeInMinutes(events[i].endTime);
          const startB = getTimeInMinutes(events[j].startTime);

          if (startB < endA) {
            overlaps.push(events[j]);
          }
        }

        const totalOverlap = overlaps.length;
        overlaps.forEach((event, index) => {
          positions.push({
            event,
            widthFactor: 1 / totalOverlap,
            leftOffsetFactor: index / totalOverlap,
          });
        });

        i += overlaps.length - 1;
      }

      return positions;
    },
    [getTimeInMinutes],
  );

  // Check if event can be dragged
  const canDragEvent = useCallback(
    (eventItem) => {
      const createdByMe = eventItem.createdById === currentUserId;
      const isBusySlot =
        eventItem.agendaType === constants.agendaType.BUSY_SLOT;
      const isBlocked = eventItem.agendaType === constants.agendaType.BLOCKED;

      if (isBusySlot || isBlocked) {
        return createdByMe;
      }

      if (eventItem?.isShift) {
        if (createdByMe) {
          return true;
        }

        const createdByOthers = eventItem.createdById !== currentUserId;
        if (createdByOthers) {
          if (isOwner) {
            return true;
          }

          if (isStaff && canEditAndViewOthersData(eventItem?.officeId)) {
            return true;
          }
        }
        return false;
      }

      if (eventItem.agendaType === constants.agendaType.EVENT) {
        return createdByMe;
      }

      return false;
    },[currentUserId, isOwner, isStaff, canEditAndViewOthersData],
  );

  // Helper function to get time range from hours array (view's time range)
  const getTimeRange = useCallback(() => {
    // Use hours array to determine range (00:00 to 23:59)
    const minHour = hours.length > 0 ? hours[0].hour : 0;
    const maxHour = hours.length > 0 ? hours[hours.length - 1].hour : 23;
    return {
      startTime: moment().hour(minHour).minute(0).second(0),
      endTime: moment().hour(maxHour).minute(59).second(59),
    };
  }, [hours]);

  // Helper function to check if time is within allowed range
  const isTimeWithinRange = useCallback((timeMoment, timeRange, baseDate) => {
    if (!timeMoment || !timeRange) return true;

    // Check if time is on the same day as baseDate
    if (baseDate && !timeMoment.isSame(baseDate, "day")) {
      return false;
    }

    const timeInMinutes = timeMoment.hour() * 60 + timeMoment.minute();
    const rangeStartMinutes =
      timeRange.startTime.hour() * 60 + timeRange.startTime.minute();
    const rangeEndMinutes =
      timeRange.endTime.hour() * 60 + timeRange.endTime.minute();

    return (
      timeInMinutes >= rangeStartMinutes && timeInMinutes <= rangeEndMinutes
    );
  },[]);

  // Calculate new date and time from drop position with 15-minute snap
  const calculateNewDateTime = useCallback(
    (eventItem, dropY, cellElement, hourIndex) => {
      if (!cellElement || !eventItem || hourIndex === undefined) {
        return null;
      }

      const cellRect = cellElement.getBoundingClientRect();
      const relativeY = dropY - cellRect.top;
      const cellHeight = cellRect.height;
      const minuteHeight = cellHeight / 60;
      const minutesFromHourStart = relativeY / minuteHeight;

      // Snap to 15-minute intervals (0, 15, 30, 45)
      const snappedMinutes = Math.round(minutesFromHourStart / 15) * 15;
      const clampedMinute = Math.max(0, Math.min(45, snappedMinutes));

      // Only the time (hour and minute) changes based on vertical drag position
      const newDate = moment(currentDate);
      const newStartTime = moment(newDate)
        .hour(hourIndex)
        .minute(clampedMinute)
        .second(0)
        .millisecond(0);

      // Get time range for validation
      const timeRange = getTimeRange();

      // Calculate duration from original event
      if (!eventItem.startTime || !eventItem.endTime) {
        // Default to 1 hour if no duration available
        const durationMinutes = 60;
        const newEndTime = moment(newStartTime).add(durationMinutes, "minutes");

        // Check if new times are within allowed range
        if (
          !isTimeWithinRange(newStartTime, timeRange, newDate) ||
          !isTimeWithinRange(newEndTime, timeRange, newDate)
        ) {
          return { error: "timeRangeExceeded" };
        }

        return {
          newDate: newDate.toDate(),
          newStartTime: newStartTime.toDate(),
          newEndTime: newEndTime.toDate(),
          newStartTimeString: newStartTime.format("YYYY-MM-DDTHH:mm"),
          newEndTimeString: newEndTime.format("YYYY-MM-DDTHH:mm"),
        };
      }

      const originalStart = moment(eventItem.startTime);
      const originalEnd = moment(eventItem.endTime);
      const durationMinutes = originalEnd.diff(originalStart, "minutes");

      const newEndTime = moment(newStartTime).add(durationMinutes, "minutes");

      // Check if new times are within allowed range
      if (
        !isTimeWithinRange(newStartTime, timeRange, newDate) ||
        !isTimeWithinRange(newEndTime, timeRange, newDate)
      ) {
        return { error: "timeRangeExceeded" };
      }

      return {
        newDate: newDate.toDate(),
        newStartTime: newStartTime.toDate(),
        newEndTime: newEndTime.toDate(),
        newStartTimeString: newStartTime.format("YYYY-MM-DDTHH:mm"),
        newEndTimeString: newEndTime.format("YYYY-MM-DDTHH:mm"),
      };
    },
    [currentDate, getTimeRange, isTimeWithinRange],
  );

  // Helper to check if time changed (similar to EditEvent)
  const getTimeCheck = useCallback((alreadyTime, selectedTime) => {
    if (alreadyTime) {
      const selectedStartTime = moment(selectedTime);
      const alreadySelectedStartTime = moment(alreadyTime);
      if (
        selectedStartTime.hour() !== alreadySelectedStartTime.hour() ||
        selectedStartTime.minute() !== alreadySelectedStartTime.minute()
      ) {
        return true;
      }
      return false;
    } else {
      return true;
    }
  },[]);

  // Internal function to perform the actual update (called directly or from modal)
  const performEventUpdate = useCallback(
    async (eventData, newDateTime, editType, originalRequestedDate = null) => {
      // ... (no changes to update logic) ...
      // Keeping existing implementation
      if (!newDateTime || !eventData) {
        toast.error(t("scheduler.invalidEventData"));
        return;
      }

      // Check what changed (similar to EditEvent verifyIfUpdated)
      const requestedDateForCheck = originalRequestedDate
        ? originalRequestedDate
        : eventData.requestedDate
          ? moment(eventData.requestedDate).format("YYYY-MM-DD")
          : eventData.startTime
            ? moment(eventData.startTime).format("YYYY-MM-DD")
            : moment(eventData.date || newDateTime.newDate).format(
                "YYYY-MM-DD",
              );

      const dateChangedResult = matchedBothDatesValues({
        eventDetail: eventData,
        repeatedEndDate: eventData.repeatedEndDate
          ? moment(eventData.repeatedEndDate).toDate()
          : moment().add(3, "month").toDate(),
        requestedDate: requestedDateForCheck,
        eventDate: newDateTime.newDate,
      });

      // Validate repeatedEndDate: if new date is after repeatedEndDate, show error
      const neverCheck =
        eventData.repeatedType ===
        addEditEventsConst.repeatedOptionsValues.never;
      if (!neverCheck && eventData.repeatedEndDate) {
        const newDateStr = moment(newDateTime.newDate).format("YYYY-MM-DD");
        const repeatedEndDateStr = moment(eventData.repeatedEndDate).format(
          "YYYY-MM-DD",
        );
        if (
          !moment(newDateStr).isBefore(repeatedEndDateStr) &&
          newDateStr !== repeatedEndDateStr
        ) {
          toast.error(t("form.errors.endGreater"));
          return;
        }
      }

      const startTimeChanged = getTimeCheck(
        eventData.startTime,
        newDateTime.newStartTimeString,
      );
      const endTimeChanged = getTimeCheck(
        eventData.endTime,
        newDateTime.newEndTimeString,
      );

      const originalRequestedDateForParams = moment(
        newDateTime?.newDate || currentDate,
      ).format("YYYY-MM-DD");

      // Calculate Date parameter using EXACT same logic as EditEvent
      const params = {
        SchedulerEventId: eventData.id,
        OwnerId: selectedOwnerId || currentUserId,
        Title: eventData.title,
        Date: moment(eventData?.date).format("YYYY-MM-DDTHH:mm"),
        StartTime: newDateTime.newStartTimeString,
        EndTime: newDateTime.newEndTimeString,
        IsAllDayEvent: eventData.isAllDayEvent || false,
        RepeatedType: eventData.repeatedType || 1,
        RepeatedDay: moment(newDateTime.newDate).isoWeekday(),
        RepeatedEndDate:
          eventData.repeatedType > 1 && eventData.repeatedEndDate
            ? moment(eventData.repeatedEndDate).format("YYYY-MM-DD")
            : null,
        Location: eventData.location || "",
        BlockForPatient: eventData.blockForPatient || false,
        Note: eventData.note || "",
        PublishAsEvent: eventData.publishAsEvent || false,
        eventEmployees: Array.isArray(eventData.eventEmployees)
          ? eventData.eventEmployees
          :[],
        EventRoles: Array.isArray(eventData.eventRoles)
          ? eventData.eventRoles
          :[],
        EventTags: Array.isArray(eventData.eventTags)
          ? eventData.eventTags
          :[],
        CreatedAt: moment().format("YYYY-MM-DDTHH:mm"),
        ReminderBeforeInMins: eventData.reminderBeforeInMins || 0,
        isDraft: eventData.isDraft || false,
        requestedDate: originalRequestedDateForParams,
        timezoneCode: eventData.timezoneCode || moment.tz.guess(),
        EditType: editType || editTypesVariables.allEvent,
        UpdateFlags: {
          isTitleEdit: false,
          isStartTimeEdit: startTimeChanged,
          isEndTimeEdit: endTimeChanged,
          isAllDayEventEdit: false,
          isNoteEdit: false,
          isLocationEdit: false,
          isReminderBeforeInMinsEdit: false,
          isEnterpriseEdit: false,
          isOfficeIdEdit: false,
          EmployeeIds: [],
          RoleIds:[],
          IsRepeatTypeChange: false,
          IsEventDateChange: false,
          IsRepeatedEndDateChange: dateChangedResult.endDateChanged,
          IsBlockForPatientChange: false,
          tagsIds: false,
        },
      };

      if (eventData.isShift) {
        params.Title = eventData.title || "";
        delete params.Location;
        delete params.Note;
        if (
          Array.isArray(eventData.eventEmployees) &&
          eventData.eventEmployees.length > 0 &&
          eventData.eventEmployees[0]
        ) {
          params.officeId = eventData.eventEmployees[0].officeId || null;
        }
      } else {
        params.IsAutoApprove = eventData.isAutoApprove || false;
      }

      // Use setterCustomSchduler to handle custom repeat patterns
      try {
        setterCustomSchduler({
          params,
          repeatedType: eventData.repeatedType || 1,
          repeatedTypeFrequency: eventData.customRepeatPattern?.unit || 1,
          repeatedTypeEvery: eventData.customRepeatPattern?.interval || 1,
          selectionType: true,
          schedule:
            eventData.customRepeatPattern?.daysOfWeek?.map(
              (d) => d?.dayOfWeek,
            ) ||[],
          selectedSlotDate:
            eventData.customRepeatPattern?.daysOfMonth?.map((d) => d?.day) ||[],
          selectedWeek: eventData.customRepeatPattern?.monthWeekNumber || 1,
          selectedDay:
            eventData.customRepeatPattern?.daysOfWeek?.map(
              (d) => d?.dayOfWeek,
            ) ||[],
          selectedMonths:
            eventData.customRepeatPattern?.monthsOfYear?.map((m) => m?.month) ||[],
          isDaySwitchOn: false,
          edit: true,
          eventDetail: eventData,
        });
      } catch (error) {
        console.warn("Error in setterCustomSchduler:", error);
      }

      // Use setterPublishOffices to handle publish settings
      try {
        const preferredOption = {
          dropdown: eventData.publishAsEvent
            ? [{ id: "allowInvitees" }]
            : eventData.isDraft
              ?[{ id: "saveDraft" }]
              : [{ id: "inviteesOnly" }],
          otherOptions:[],
        };
        setterPublishOffices({
          preferredOption,
          userIds: Array.isArray(eventData.eventEmployees)
            ? eventData.eventEmployees
            :[],
          publishAsEvent: eventData.publishAsEvent
            ? "allowInvitees"
            : eventData.isDraft
              ? "saveDraft"
              : "inviteesOnly",
          nonInviteesPublish: eventData.publishedType || "allOffices",
          params,
          officeIdForNonInvitee: Array.isArray(
            eventData.schedulerEventPublishedOffices,
          )
            ? eventData.schedulerEventPublishedOffices.filter(
                (office) => office && office.id,
              )
            :[],
          edit: true,
          isDraft: eventData.isDraft || false,
        });
      } catch (error) {
        console.warn("Error in setterPublishOffices:", error);
      }

      await createSchedulerEventMutation.mutateAsync(params);

      // Invalidate query cache to refresh data
      queryClient.invalidateQueries(["office_agenda"]);

      toast.success(t("staff.eventUpdated"));
    },[
      selectedOwnerId,
      currentUserId,
      createSchedulerEventMutation,
      t,
      queryClient,
      getTimeCheck,
    ],
  );

  // Update event/shift via API (with EditEvent-style checks and modal)
  const updateEventAfterDrag = useCallback(
    async (eventItem, newDateTime, editType = null) => {
      // ... (no changes to update logic) ...
      // Keeping existing implementation
      if (!newDateTime || !eventItem || !eventItem.id) {
        toast.error(t("scheduler.invalidEventData"));
        return;
      }

      try {
        const originalRequestedDate = moment(
          currentDate || newDateTime?.newDate || eventItem.startTime,
        ).format("YYYY-MM-DD");

        const eventDetails = await getEventListDetails(
          eventItem.id,
          originalRequestedDate,
        );
        const eventData = eventDetails?.data;

        if (!eventData) {
          toast.error(t("scheduler.eventNotFound"));
          return;
        }

        const dateChangedResult = {
          startDateChanged: false,
          endDateChanged: false,
        };

        // Calculate repeatedOptionChanged (should be false for drag-drop as were not changing pattern)
        const repeatedOptionChanged = matchedBothPatternValues({
          repeatedType: eventData.repeatedType || 1,
          repeatedTypeFrequency: eventData.customRepeatPattern?.unit || 1,
          repeatedTypeEvery: eventData.customRepeatPattern?.interval || 1,
          selectionType: true,
          schedule:
            eventData.customRepeatPattern?.daysOfWeek?.map(
              (d) => d?.dayOfWeek,
            ) ||[],
          selectedSlotDate:
            eventData.customRepeatPattern?.daysOfMonth?.map((d) => d?.day) ||[],
          selectedWeek: eventData.customRepeatPattern?.monthWeekNumber || 1,
          selectedDay:
            eventData.customRepeatPattern?.daysOfWeek?.map(
              (d) => d?.dayOfWeek,
            ) ||[],
          selectedMonths:
            eventData.customRepeatPattern?.monthsOfYear?.map((m) => m?.month) ||[],
          isDaySwitchOn: false,
          edit: true,
          eventDetail: eventData,
        });

        // Calculate anyChangedForDate (same as EditEvent)
        const anyChangedForDate =
          dateChangedResult.startDateChanged ||
          dateChangedResult.endDateChanged ||
          repeatedOptionChanged;

        const startTimeChanged = getTimeCheck(
          eventData.startTime,
          newDateTime.newStartTimeString,
        );
        const endTimeChanged = getTimeCheck(
          eventData.endTime,
          newDateTime.newEndTimeString,
        );

        const hasChanges =
          dateChangedResult.startDateChanged ||
          dateChangedResult.endDateChanged ||
          startTimeChanged ||
          endTimeChanged;

        // Validate repeatedEndDate: if new date is after repeatedEndDate, show error
        const neverCheck =
          eventData.repeatedType ===
          addEditEventsConst.repeatedOptionsValues.never;
        if (!neverCheck && eventData.repeatedEndDate) {
          const newDateStr = moment(newDateTime.newDate).format("YYYY-MM-DD");
          const repeatedEndDateStr = moment(eventData.repeatedEndDate).format(
            "YYYY-MM-DD",
          );
          if (
            !moment(newDateStr).isBefore(repeatedEndDateStr) &&
            newDateStr !== repeatedEndDateStr
          ) {
            toast.error(t("form.errors.endGreater"));
            return;
          }
        }

        // Check if event is repeating (similar to EditEvent logic)
        const isNotDrafted = !eventData.isDraft;

        // If event is repeating, has changes, is not a draft, and no editType provided, show modal
        if (!neverCheck && !editType && hasChanges && isNotDrafted) {
          // Store update parameters for modal confirmation
          setPendingDragUpdate({
            eventData,
            newDateTime,
            anyChangedForDate,
            originalRequestedDate,
          });
          setEditModalConfirmation(true);
          return;
        }

        // Determine EditType based on repeatedType (similar to EditEvent)
        let finalEditType = editType;
        if (!finalEditType) {
          if (neverCheck) {
            finalEditType = editTypesVariables.allEvent;
          } else {
            finalEditType = editTypesVariables.allEvent;
          }
        }

        // Perform the update - pass originalRequestedDate for correct date change detection
        await performEventUpdate(
          eventData,
          newDateTime,
          finalEditType,
          originalRequestedDate,
        );
      } catch (error) {
        toast.error(error.message || t("scheduler.updateFailed"));
        throw error;
      }
    },[t, getTimeCheck, performEventUpdate],
  );

  // Internal function to perform the actual busy slot update (called directly or from modal)
  const performBusySlotUpdate = useCallback(
    async (
      busySlotData,
      newDateTime,
      editType,
      officeDetails,
      officeIds,
      busySlotEmployeeView,
      isAllDayBusy,
      repeatedType,
      repeatedEndDate,
      originalRequestedDate,
      UpdateFlags,
    ) => {
      // ... (no changes to update logic) ...
      // Keeping existing implementation
      if (!newDateTime || !busySlotData) {
        toast.error(t("scheduler.invalidEventData"));
        return;
      }

      // Format dates and times
      const eventDateMoment = moment(newDateTime.newDate);
      const startTime = moment(newDateTime.newStartTime);
      const endTime = moment(newDateTime.newEndTime);

      // Get requestedDate for Date calculation (same as EditEvent line 193)
      const requestedDateForDateCalc = originalRequestedDate
        ? moment(originalRequestedDate).toDate()
        : busySlotData.requestedDate
          ? moment(busySlotData.requestedDate).toDate()
          : busySlotData.startTime
            ? moment(busySlotData.startTime).toDate()
            : null;

      // Helper function to format time like AddBusySlots startOrEndTimeValue
      const formatBusySlotTime = (timeValue, startOrEnd) => {
        if (isAllDayBusy) {
          return moment(eventDateMoment)
            [startOrEnd]("day")
            .format("YYYY-MM-DDTHH:mm");
        }
        if (!timeValue) {
          return null;
        }
        return (
          moment(eventDateMoment).format("YYYY-MM-DDT") +
          moment(timeValue).format("HH:mm")
        );
      };

      // Build params exactly like AddBusySlots
      const params = {
        OwnerId: officeDetails.ownerId,
        OfficeIds: officeIds,
        Title: busySlotData.title || "",
        Date: moment(busySlotData?.date).format("YYYY-MM-DDTHH:mm"),
        StartTime: formatBusySlotTime(startTime, "startOf"),
        EndTime: formatBusySlotTime(endTime, "endOf"),
        repeatedType: +repeatedType,
        CreatedAt: moment().format("YYYY-MM-DDTHH:mm"),
        repeatedDay: +repeatedType === 1 ? null : eventDateMoment.isoWeekday(),
        RepeatedEndDate:
          +repeatedType === 1
            ? null
            : moment(repeatedEndDate).format("YYYY-MM-DD"),
        Location: busySlotData.location || "",
        Description: busySlotData.description || "",
        IsNotifyEmployee: busySlotData.isNotifyEmployee || false,
        BusySlotEmployeeView: busySlotEmployeeView,
        IsAllDayBusy: isAllDayBusy,
      };

      // Call setterCustomSchduler to handle custom repeat patterns
      try {
        setterCustomSchduler({
          params,
          repeatedType: repeatedType,
          repeatedTypeFrequency: busySlotData.customRepeatPattern?.unit || 1,
          repeatedTypeEvery: busySlotData.customRepeatPattern?.interval || 1,
          selectionType: true,
          schedule:
            busySlotData.customRepeatPattern?.daysOfWeek?.map(
              (d) => d?.dayOfWeek,
            ) ||[],
          selectedSlotDate:
            busySlotData.customRepeatPattern?.daysOfMonth?.map((d) => d?.day) ||[],
          selectedWeek: busySlotData.customRepeatPattern?.monthWeekNumber || 1,
          selectedDay:
            busySlotData.customRepeatPattern?.daysOfWeek?.map(
              (d) => d?.dayOfWeek,
            ) ||[],
          selectedMonths:
            busySlotData.customRepeatPattern?.monthsOfYear?.map(
              (m) => m?.month,
            ) ||[],
          isDaySwitchOn: false,
          edit: true,
          eventDetail: busySlotData,
        });
      } catch (error) {
        console.warn("Error in setterCustomSchduler:", error);
      }

      // Add edit-specific fields
      params.UpdateFlags = UpdateFlags;
      params.EditType = editType || 3;
      params.SchedulerBusySlotId = busySlotData.id;
      params.RequestedDate = originalRequestedDate;
      // Delete isRepeated when editing (as per AddBusySlots)
      delete params.isRepeated;

      await updateBusySlot(params);

      // Invalidate query cache to refresh data
      queryClient.invalidateQueries(["office_agenda"]);

      toast.success(t("scheduler.busySlotUpdated"));
    },
    [t, queryClient],
  );

  // Update busy slot via API (matching EditBusySlot handleBlock logic)
  const updateBusySlotAfterDrag = useCallback(
    async (eventItem, newDateTime, editType = null) => {
      // ... (no changes to update logic) ...
      // Keeping existing implementation
      if (!newDateTime || !eventItem || !eventItem.id) {
        toast.error(t("scheduler.invalidEventData"));
        return;
      }

      try {
        const originalRequestedDate = moment(
          currentDate || newDateTime?.newDate,
        ).format("YYYY-MM-DD");

        let busySlotDetails = null;
        try {
          busySlotDetails = await getBusySlot({
            queryKey:[
              "busy-slot-details",
              eventItem.id,
              originalRequestedDate,
            ],
          });
        } catch (error) {
          toast.error(error.message || t("scheduler.updateFailed"));
          return;
        }

        const busySlotData = busySlotDetails?.data;

        if (!busySlotData) {
          toast.error(t("scheduler.eventNotFound"));
          return;
        }

        // Fetch office details to get correct ownerId and officeId
        const officeId = busySlotData.officeId || eventItem.officeId;
        if (!officeId) {
          toast.error(t("scheduler.officeIdRequired"));
          return;
        }

        let officeDetails = null;
        try {
          officeDetails = await getOfficeDetail(officeId);
        } catch (error) {
          toast.error(
            error.message || t("scheduler.failedToFetchOfficeDetails"),
          );
          return;
        }

        if (!officeDetails) {
          toast.error(t("scheduler.officeDetailsNotFound"));
          return;
        }

        // Determine if it's all-day event
        const isAllDayBusy =
          eventItem.isAllDayBusy ||
          eventItem.isAllDayEvent ||
          !eventItem.startTime ||
          !eventItem.endTime;

        // Format dates and times exactly like AddBusySlots
        const eventDate = moment(newDateTime.newDate);
        const startTime = moment(newDateTime.newStartTime);
        const endTime = moment(newDateTime.newEndTime);

        const repeatedType = +(busySlotData.repeatedType || 1);
        const repeatedEndDate = busySlotData.repeatedEndDate
          ? moment(busySlotData.repeatedEndDate)
          : moment().toDate();

        // Helper function to format time like AddBusySlots startOrEndTimeValue
        const formatBusySlotTime = (timeValue, startOrEnd) => {
          if (isAllDayBusy) {
            return moment(eventDate)
              [startOrEnd]("day")
              .format("YYYY-MM-DDTHH:mm");
          }
          if (!timeValue) {
            return null;
          }
          return (
            moment(eventDate).format("YYYY-MM-DDT") +
            moment(timeValue).format("HH:mm")
          );
        };

        // Build OfficeIds array
        let officeIds =[];
        if (
          busySlotData.schedulerBusySlotOffice &&
          Array.isArray(busySlotData.schedulerBusySlotOffice)
        ) {
          officeIds = busySlotData.schedulerBusySlotOffice.map((ele) => ({
            id: ele.externalId || ele.id || 0,
            SchedulerBusySlotId: busySlotData.id,
            OfficeId: ele.officeId,
            IsDeleted: false,
          }));
        } else {
          officeIds =[
            {
              id: 0,
              SchedulerBusySlotId: busySlotData.id,
              OfficeId: officeId,
              IsDeleted: false,
            },
          ];
        }

        // Build BusySlotEmployeeView
        const busySlotEmployeeView = (
          busySlotData.busySlotNotifiedUsers ||
          eventItem.busySlotNotifiedUsers ||[]
        ).map((item) => ({
          userid: item.userId,
          OfficeId: item.officeId || officeId,
        }));

        const dateChangedResult = {
          startDateChanged: false,
          endDateChanged: false,
        };

        // Calculate repeatedOptionChanged using matchedBothPatternValues
        const repeatedOptionChanged = matchedBothPatternValues({
          repeatedType: repeatedType,
          repeatedTypeFrequency: busySlotData.customRepeatPattern?.unit || 1,
          repeatedTypeEvery: busySlotData.customRepeatPattern?.interval || 1,
          selectionType: true,
          schedule:
            busySlotData.customRepeatPattern?.daysOfWeek?.map(
              (d) => d?.dayOfWeek,
            ) ||[],
          selectedSlotDate:
            busySlotData.customRepeatPattern?.daysOfMonth?.map((d) => d?.day) ||[],
          selectedWeek: busySlotData.customRepeatPattern?.monthWeekNumber || 1,
          selectedDay:
            busySlotData.customRepeatPattern?.daysOfWeek?.map(
              (d) => d?.dayOfWeek,
            ) ||[],
          selectedMonths:
            busySlotData.customRepeatPattern?.monthsOfYear?.map(
              (m) => m?.month,
            ) ||[],
          isDaySwitchOn: false,
          edit: true,
          eventDetail: busySlotData,
        });

        // Calculate anyChangedForDate
        const anyChangedForDate =          repeatedOptionChanged;

        // Validate repeatedEndDate
        const neverCheck =
          repeatedType === addEditEventsConst.repeatedOptionsValues.never;
        if (!neverCheck && busySlotData.repeatedEndDate) {
          const newDateStr = moment(eventDate).format("YYYY-MM-DD");
          const repeatedEndDateStr = moment(
            busySlotData.repeatedEndDate,
          ).format("YYYY-MM-DD");
          if (
            !moment(newDateStr).isBefore(repeatedEndDateStr) &&
            newDateStr !== repeatedEndDateStr
          ) {
            toast.error(t("form.errors.endGreater"));
            return;
          }
        }

        // Build UpdateFlags
        const UpdateFlags = {
          isTitleEdit: false,
          isStartTimeEdit: getTimeCheck(
            busySlotData.startTime,
            formatBusySlotTime(startTime, "startOf"),
          ),
          isEndTimeEdit: getTimeCheck(
            busySlotData.endTime,
            formatBusySlotTime(endTime, "endOf"),
          ),
          IsAllDayBusyEdit: busySlotData.isAllDayBusy !== isAllDayBusy,
          isLocationEdit: false,
          IsDescriptionEdit: false,
          IsOfficeEdit: false,
          IsNotifiedUserEdit: false,
          IsNotifiedStaffListEdit: false,
          IsRepeatTypeChange: repeatedOptionChanged,
          IsBusySlotDateChange: false,
          IsRepeatedEndDateChange: dateChangedResult.endDateChanged,
          OfficeIds:[],
          BusySlotEmployeeView:[],
        };

        // Check if there are any changes
        const verified = {
          UpdateFlags,
          changedCheck: Object.values(UpdateFlags || {})?.some((value) =>
            typeof value === "boolean" ? value : value?.length > 0,
          ),
        };

        if (
          !neverCheck &&
          !editType &&
          (verified.changedCheck || anyChangedForDate)
        ) {
          setPendingDragUpdate({
            busySlotData,
            newDateTime,
            anyChangedForDate,
            isBusySlot: true,
            UpdateFlags,
            officeDetails,
            officeIds,
            busySlotEmployeeView,
            isAllDayBusy,
            repeatedType,
            repeatedEndDate,
            originalRequestedDate,
            eventItem,
          });
          setEditModalConfirmation(true);
          return;
        }

        // Determine EditType based on repeatedType
        let finalEditType = editType;
        if (!finalEditType) {
          if (neverCheck) {
            finalEditType = 3;
          } else {
            finalEditType = 3;
          }
        }

        // Perform the update
        await performBusySlotUpdate(
          busySlotData,
          newDateTime,
          finalEditType,
          officeDetails,
          officeIds,
          busySlotEmployeeView,
          isAllDayBusy,
          repeatedType,
          repeatedEndDate,
          originalRequestedDate,
          UpdateFlags,
        );
      } catch (error) {
        toast.error(error.message || t("scheduler.updateFailed"));
        throw error;
      }
    },
    [t, queryClient, getTimeCheck, performBusySlotUpdate],
  );

  const goToDetails = useCallback(
    (id, type, createdByMe, requestedDate) => {
      if (!id || !type) return;
      const locationStateSending = {
        requestedDate,
        fromScreen: isSchedulingAssistant
          ? "schedulingAssistant"
          : "staffSchedule",
        schedulingAssistantState: {
          selectedStaff,
          currentDate,
        },
        eventId: eventIdFromUrl,
      };
      switch (type) {
        case constants.agendaType.EVENT: {
          let pathname = "/";
          pathname = createdByMe
            ? constants.routes.scheduler.eventDetails.replace(
                ":eventId",
                encodeId(id),
              )
            : constants.routes.scheduler.eventDetailsOnly.replace(
                ":eventId",
                encodeId(id),
              );
          history.replace({
            state: locationStateSending,
            search:window.location.search,
          });

          history.push({
            pathname,
            state: locationStateSending,
            search: effectiveOwnerIdString ? `?${effectiveOwnerIdString}` : "",
          });
          break;
        }
        case constants.agendaType.BUSY_SLOT: {
          const pathname = constants.routes.scheduler.busySlotDetail.replace(
            ":busySlotId",
            encodeId(id),
          );
          history.replace({
            state: locationStateSending,
            search:window.location.search,
          });
          history.push({
            pathname,
            state: locationStateSending,
            search: effectiveOwnerIdString ? `?${effectiveOwnerIdString}` : "",
          });
          break;
        }
        default: {
          return;
        }
      }
    },
    [history, selectedStaff, currentDate, effectiveOwnerIdString],
  );

  // Handle drag start
  const handleDragStart = useCallback(
    (e, eventItem, fullEvent, originalColumnIndex = null) => {
      if (!canDragEvent(eventItem)) {
        e.preventDefault();
        return;
      }

      const rect = e.currentTarget.getBoundingClientRect();
      const offsetX = e.clientX - rect.left;
      const offsetY = e.clientY - rect.top;

      // Store original date
      let originalDate = null;
      if (eventItem.date) {
        originalDate = moment(eventItem.date).startOf("day");
      } else if (eventItem.startTime) {
        originalDate = moment(eventItem.startTime).startOf("day");
      }

      setDraggedEvent({
        eventItem,
        fullEvent,
        originalDate: originalDate ? originalDate.format("YYYY-MM-DD") : null,
        originalColumnIndex,
      });
      setIsDragging(true);
      setOpenTooltipId(null);

      // Create drag preview
      const dragImage = e.currentTarget.cloneNode(true);
      dragImage.style.opacity = "0";
      dragImage.style.position = "absolute";
      dragImage.style.top = "-1000px";
      document.body.appendChild(dragImage);
      e.dataTransfer.setDragImage(dragImage, offsetX, offsetY);
      setTimeout(() => document.body.removeChild(dragImage), 0);
    },
    [canDragEvent],
  );

  // Handle drag over - validate drop zone and show preview
  const handleDragOver = useCallback(
    (e, hourIndex) => {
      if (!draggedEvent) {
        e.preventDefault();
        return;
      }

      const { eventItem } = draggedEvent;
      const isDraggedAllDay = isAllDayEvent(eventItem);

      // For daily view, we only allow time-based events (no all-day in time rows)
      if (isDraggedAllDay) {
        e.preventDefault();
        e.dataTransfer.dropEffect = "none";
        setDragPreviewPosition(null);
        return;
      }

      e.preventDefault();
      e.dataTransfer.dropEffect = "move";

      // Calculate preview position for time-based events
      const cellElement = e.currentTarget;
      const cellRect = cellElement.getBoundingClientRect();
      const relativeY = e.clientY - cellRect.top;
      const cellHeight = cellRect.height;
      const minuteHeight = cellHeight / 60;
      const minutesFromHourStart = relativeY / minuteHeight;

      // Snap to 15-minute intervals
      const snappedMinutes = Math.round(minutesFromHourStart / 15) * 15;
      const clampedMinute = Math.max(0, Math.min(45, snappedMinutes));

      // Calculate duration from original event
      const originalStart = moment(eventItem.startTime);
      const originalEnd = moment(eventItem.endTime);
      const durationMinutes = originalEnd.diff(originalStart, "minutes");

      const topPercent = (clampedMinute / 60) * 100;
      const heightPercent = (durationMinutes / 60) * 100;

      setDragPreviewPosition({
        hourIndex,
        topPercent,
        heightPercent,
        clampedMinute,
      });
    },
    [draggedEvent, isAllDayEvent],
  );

  // Handle drop for time-based events
  const handleDrop = useCallback(
    async (e, hourIndex) => {
      e.preventDefault();
      if (!draggedEvent || !draggedEvent.eventItem) {
        setIsDragging(false);
        setDraggedEvent(null);
        setDragPreviewPosition(null);
        return;
      }

      const { eventItem } = draggedEvent;
      if (!eventItem || !eventItem.id) {
        setIsDragging(false);
        setDraggedEvent(null);
        setDragPreviewPosition(null);
        return;
      }

      const isDraggedAllDay = isAllDayEvent(eventItem);

      // For daily view, we only allow time-based events
      if (isDraggedAllDay) {
        toast.error(t("scheduler.cannotMoveAllDayToTimeBased"));
        setIsDragging(false);
        setDraggedEvent(null);
        setDragPreviewPosition(null);
        return;
      }

      const cellElement = e.currentTarget;
      const newDateTime = calculateNewDateTime(
        eventItem,
        e.clientY,
        cellElement,
        hourIndex,
      );

      // Check for time range exceeded error
      if (newDateTime && newDateTime.error === "timeRangeExceeded") {
        toast.error("You can't move the event outside the time range");
        setIsDragging(false);
        setDraggedEvent(null);
        setDragPreviewPosition(null);
        return;
      }

      if (!newDateTime) {
        setIsDragging(false);
        setDraggedEvent(null);
        setDragPreviewPosition(null);
        return;
      }

      // Check if dropped on same time - if so, don't call API
      if (eventItem.startTime && newDateTime.newStartTime) {
        const originalStartTime = moment(eventItem.startTime);
        const newStartTime = moment(newDateTime.newStartTime);
        if (
          originalStartTime.hour() === newStartTime.hour() &&
          originalStartTime.minute() === newStartTime.minute()
        ) {
          setIsDragging(false);
          setDraggedEvent(null);
          setDragPreviewPosition(null);
          return;
        }
      }

      setIsDragDropLoading(true);
      try {
        if (
          eventItem.agendaType === constants.agendaType.BUSY_SLOT ||
          eventItem.agendaType === constants.agendaType.BLOCKED
        ) {
          await updateBusySlotAfterDrag(eventItem, newDateTime);
        } else {
          await updateEventAfterDrag(eventItem, newDateTime);
        }
      } catch (error) {
      } finally {
        setIsDragDropLoading(false);
        setIsDragging(false);
        setDraggedEvent(null);
        setDragPreviewPosition(null);
      }
    },[
      draggedEvent,
      isAllDayEvent,
      calculateNewDateTime,
      updateEventAfterDrag,
      updateBusySlotAfterDrag,
      t,
    ],
  );

  // Handle drag end
  const handleDragEnd = useCallback(() => {
    if (!isDragDropLoading) {
      setIsDragging(false);
      setDraggedEvent(null);
      setDragPreviewPosition(null);
    }
  }, [isDragDropLoading]);

  // Helper functions for event grouping and overlap calculation (from SchedulingTable)
  const groupEventsByStartTime = useCallback(
    (events) => {
      const grouped = {};
      events.forEach((event) => {
        const startMinutes = getTimeInMinutes(event.startTime);
        if (!grouped[startMinutes]) {
          grouped[startMinutes] = [];
        }
        grouped[startMinutes].push(event);
      });
      return grouped;
    },
    [getTimeInMinutes],
  );

  // Get current date key
  const currentDateKey = useMemo(() => {
    if (!currentDate) return null;
    return moment(currentDate).format("MMM DD, ddd");
  }, [currentDate]);

  // Get date object for current date
  const dateObj = useMemo(() => {
    if (!currentDateKey || !filteredAgendaFilter?.length) return null;
    return filteredAgendaFilter.find(
      (d) => moment(d.requestedDate).format("MMM DD, ddd") === currentDateKey,
    );
  }, [currentDateKey, filteredAgendaFilter]);

  const holidayList = dateObj?.holidayList ||[];
  const officeSchedulerList =
    filteredAgendaFilter?.[0]?.officeSchedulerList ||[];

  // Update findCommonAvailabilitySlots to use 1-minute increments
  const findCommonAvailabilitySlots = useCallback(
    (staffList, officeStart, officeEnd) => {
      // Convert each staff's schedule into busy time slots
      const busySlots = staffList.map((staff) => {
        const allEvents = getAllStaffEvents(staff);
        return allEvents.map((event) => ({
          start: getTimeInMinutes(event.startTime),
          end: getTimeInMinutes(event.endTime),
        }));
      });

      // Find all possible time slots (in 1-minute increments)
      const timeSlots =[];

      // Calculate office hours range in minutes
      const officeStartMinutes = officeStart
        ? getTimeInMinutes(officeStart)
        : 0;
      const officeEndMinutes = officeEnd
        ? getTimeInMinutes(officeEnd)
        : 24 * 60;

      for (
        let minute = officeStartMinutes;
        minute < officeEndMinutes;
        minute += 1
      ) {
        const startTime = minute;
        const endTime = startTime + 1;
        timeSlots.push({ start: startTime, end: endTime });
      }
      // Find slots where all staff are free
      const commonAvailability = timeSlots.filter((slot) => {
        return !busySlots.some((staffBusySlots) =>
          staffBusySlots.some(
            (busySlot) =>
              // Fixed boundary condition: slot overlaps if it touches or crosses event boundaries
              slot.start < busySlot.end && slot.end > busySlot.start,
          ),
        );
      });

      // Merge consecutive slots
      const mergedSlots =[];
      let currentSlot = null;

      commonAvailability.forEach((slot) => {
        if (!currentSlot) {
          currentSlot = { ...slot };
        } else if (slot.start === currentSlot.end) {
          currentSlot.end = slot.end;
        } else {
          mergedSlots.push(currentSlot);
          currentSlot = { ...slot };
        }
      });

      if (currentSlot) {
        mergedSlots.push(currentSlot);
      }

      // Filter slots that are at least 1 minute long
      return mergedSlots.filter((slot) => slot.end - slot.start >= 1);
    },[],
  );

  const commonAvailabilitySlots = useMemo(() => {
    if (showFreeSlots && filteredAgendaFilter.length) {
      const dateObj = filteredAgendaFilter?.find((d) =>
        moment(d.requestedDate)
          .startOf("day")
          .isSame(moment(currentDate).startOf("day")),
      );
      if (dateObj?.officeSchedulerList) {
        return findCommonAvailabilitySlots(
          dateObj.officeSchedulerList,
          findAvailabilityData.officeStart,
          findAvailabilityData.officeEnd,
        );
      }
    }

    return [];
  },[
    showFreeSlots,
    currentDate,
    filteredAgendaFilter,
    findCommonAvailabilitySlots,
    findAvailabilityData,
  ]);
  const firstAvailabilitySlotRef = useRef(null);
  const scrollReferenceForFirst = useRef(null);
  // Scroll to first availability slot when slots are available
  useEffect(() => {
    if (
      commonAvailabilitySlots.length > 0 &&
      firstAvailabilitySlotRef.current &&
      focusOnFirstAvailableSlot?.current
    ) {
      // Use setTimeout to ensure the element is rendered before scrolling
      scrollReferenceForFirst.current = null;
      setTimeout(() => {
        firstAvailabilitySlotRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "nearest",
        });
        if (resetFocusRef) {
          resetFocusRef();
        }
      }, 1000);
    }
  }, [commonAvailabilitySlots]);

  if (isLoading || isFreeStotLoading) {
    return <Loader />;
  }

  if (!dailyData?.data?.length && !isLoading) {
    return <Empty Message={t("scheduler.noEventsFound")} />;
  }

  return (
    // Added position: relative to creating positioning context for absolute popup
    <div
      className={styles.tableContainer}
      ref={tableContainerRef}
      style={{
        position: "relative",
        // Dynamic Height Logic:
        // overflow: auto -> enables scrollbars when content exceeds dynamic height
        // maxHeight -> Calculated dynamically based on window scroll position
        // width: 100% -> Ensures full width usage
        overflow: "auto",
        maxHeight: tableHeight,
        width: "100%",
      }}
      onScroll={() => {
        if (openTooltipId) {
          setOpenTooltipId(null);
        }
      }}
    >
      {(isLoading || isFreeStotLoading) && <Loader />}
      <table className={styles.table}>
        <thead className={styles.scheduling_table_head}>
          {/* Row 1: Staff member headers */}
          <tr className={styles.headerRow}>
            <th className={styles.firstCol}>
              <p className={styles.empty_tag}></p>
            </th>
            {officeSchedulerList?.map((staff) => (
              <th
                className={styles.tableCell}
                key={staff.user?.id || staff.id}
                style={{ borderTop: "none" }}
              >
                <div className={`${styles.table_header_new}`}>
                  <div className={`${styles.client_img}`}>
                    <img
                      src={staff.user?.profilePic || defautUserImage}
                      alt={`${staff?.user?.firstName || ""} ${
                        staff?.user?.lastName || ""
                      }`}
                      onError={(e) => {
                        e.currentTarget.src = defautUserImage;
                      }}
                    />
                  </div>
                  <span className={styles.table_header_name}>
                    {staff?.user?.firstName || ""} {staff?.user?.lastName || ""}
                  </span>
                </div>
              </th>
            ))}
          </tr>
          {/* Row 2: All-day events */}
          <tr
            className={styles.headerRow}
            style={{ backgroundColor: "white", height: "43px" }}
          >
            <th
              className={`${styles.firstCol} ${styles.all_day_event_header} ${styles.all_day_text} p-0 border-0`}
            >
              <p>all-day</p>
            </th>
            {officeSchedulerList.map((scheduler, colIdx) => {
              const allEvents = getAllStaffEvents(scheduler);
              const allDayEvents = filterEventsBySearch(
                allEvents.filter(
                  (event) => event.isAllDayEvent || event.isAllDayBusy,
                ),
                scheduler.user,
                searchValue,
              );
              return (
                <td
                  className={styles.tableCell}
                  key={colIdx}
                  style={{ height: "43px", borderTop: "none" }}
                >
                  <div
                    className={`${styles.table_cell_data_container} ${styles.table_cell_all_day}`}
                  >
                    {Object.entries(groupEventsByStartTime(allDayEvents)).map(
                      ([startMinutesStr, group], idx) => {
                        const overlapPositions =
                          calculateOverlapPositions(group);

                        return overlapPositions.map(({ event }, index) => {
                          const eventColor = getEventColor(event, index);
                          const borderColor = getEventBorderColor(event);
                          const createdByOthers =
                            event?.isShift &&
                            profile?.id !== event?.createdById;

                          // Determine if should navigate or show popup (same logic as hourly events)
                          let shouldNavigate = false;
                          let shouldShowPopup = false;

                          if (event.agendaType === constants.agendaType.EVENT) {
                            shouldNavigate =
                              currentUserId === event.createdById ||
                              (createdByOthers &&
                                canEditAndViewOthersData(event?.officeId));
                            shouldShowPopup = !shouldNavigate;
                          } else if (
                            event.agendaType ===
                              constants.agendaType.BUSY_SLOT ||
                            event.agendaType === constants.agendaType.BLOCKED
                          ) {
                            shouldNavigate =
                              currentUserId === event.createdById;
                            shouldShowPopup = !shouldNavigate;
                          } else if (
                            event.agendaType ===
                            constants.agendaType.APPOINTMENT
                          ) {
                            shouldShowPopup = true;
                          } else if (
                            event.agendaType === constants.agendaType.LEAVE
                          ) {
                            shouldShowPopup = true;
                          }

                          const thisHoverKey = `allday-${colIdx}-${idx}-${index}`;
                          const tooltipId = `tooltip-allday-${colIdx}-${idx}-${index}-${
                            event?.id || index
                          }`;

                          // Get office color from officeColourCodes
                          const staffAssignedColor = getOfficeColor(
                            scheduler.user,
                            selectedOwnerId,
                          );

                          return (
                            <React.Fragment
                              key={`allday-${colIdx}-${idx}-${index}`}
                            >
                              <div
                                id={tooltipId}
                                className={styles.overlap_position_event}
                                style={{
                                  backgroundColor: eventColor,
                                  width: 100 / overlapPositions.length + "%",
                                  cursor:
                                    shouldNavigate || shouldShowPopup
                                      ? "pointer"
                                      : "default",
                                  border: "1px solid rgba(0, 0, 0, 0.3)",
                                }}
                                onMouseEnter={() => {
                                  if (!isDragging) {
                                    toggleTooltip(tooltipId);
                                  }
                                }}
                                onMouseLeave={() => {
                                  if (!isDragging) {
                                    toggleTooltip(tooltipId);
                                  }
                                }}
                                onClick={(e) => {
                                  if (isDragging) {
                                    e.preventDefault();
                                    return;
                                  }
                                  if (shouldNavigate) {
                                    goToDetails(
                                      event.id,
                                      event.agendaType,
                                      true,
                                      currentDate,
                                    );
                                  } else if (shouldShowPopup) {
                                    // Call helper to handle positioning logic
                                    handlePopupClick(
                                      e,
                                      event,
                                      scheduler,
                                      thisHoverKey,
                                    );
                                  }
                                }}
                              >
                                <div className={styles.event_display_text}>
                                  {getEventDisplayText(event, scheduler?.user)}
                                </div>
                              </div>
                              <Tooltip
                                placement="top"
                                isOpen={openTooltipId === tooltipId}
                                target={tooltipId}
                                autohide={false}
                                toggle={() => toggleTooltip(tooltipId)}
                                className="weekly_list_tooltip_style"
                              >
                                <div
                                  className={
                                    staffAvailabilityStyles.tooltip_content
                                  }
                                >
                                  <div
                                    className={
                                      staffAvailabilityStyles.image_border
                                    }
                                    style={{
                                      border: `2px solid ${staffAssignedColor}`,
                                    }}
                                  >
                                    <img
                                      src={
                                        scheduler.user?.profilePic ||
                                        defautUserImage
                                      }
                                      onError={(e) => {
                                        e.currentTarget.src = defautUserImage;
                                      }}
                                      alt={event?.title || ""}
                                      className={
                                        staffAvailabilityStyles.tooltip_image
                                      }
                                    />
                                  </div>
                                  <div>
                                    <p
                                      className={
                                        staffAvailabilityStyles.staff_name
                                      }
                                    >
                                      {scheduler.user?.fullName}
                                    </p>
                                    {renderOfficeNameOrEnterprise(event, t) && (
                                      <div
                                        className={staffAvailabilityStyles.chip}
                                        style={{
                                          backgroundColor: staffAssignedColor,
                                          color: "#FFFFFF",
                                        }}
                                      >
                                        {renderOfficeNameOrEnterprise(event, t)}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </Tooltip>
                            </React.Fragment>
                          );
                        });
                      },
                    )}
                  </div>
                </td>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {/* Holiday Row */}
          {holidayList.length > 0 && (
            <tr>
              <td className={`${styles.firstCol}`}></td>
              <td
                colSpan={officeSchedulerList?.length}
                className={`p-0 ${styles.holiday_cell} ${
                  holidayList.length > 0
                    ? styles["light-red-bg"]
                    : styles["no-bg-theme"]
                }`}
              >
                <div className={styles.holiday_title}>
                  <img
                    src={HolidayImage}
                    alt="holiday"
                    className="account_owner_image mr-2"
                    style={{ height: 24, verticalAlign: "middle" }}
                  />
                  <span>{holidayList[0]?.title}</span>
                </div>
              </td>
            </tr>
          )}
          {/* Time rows */}
          {hours.map((hour, rowIdx) => (
            <tr
              className={styles.row}
              key={hour.hour}
              ref={rowIdx === scrollHour ? currentHourRowRef : null}
            >
              <td
                className={styles.firstCol}
                onClick={() => {
                  if (typeof onTimeLabelClick === "function")
                    onTimeLabelClick(rowIdx);
                }}
                style={{
                  borderLeft: "1px solid #ddd",
                  borderRight: "1px solid #ddd",
                  ...(selectedHourIdx === rowIdx
                    ? {
                        borderTop: "2px solid #a9cf3d",
                        borderBottom: "2px solid #a9cf3d",
                        borderLeft: "2px solid #a9cf3d",
                      }
                    : {}),
                  cursor: "pointer",
                  position: "relative",
                }}
              >
                <p className={styles.ptext}>{hour.label}</p>
                {startTime &&
                  (() => {
                    const startHour = moment.isMoment(startTime)
                      ? startTime.hour()
                      : moment(startTime,["h:mm A", "HH:mm"]).hour();
                    const startMinute = moment.isMoment(startTime)
                      ? startTime.minute()
                      : moment(startTime,["h:mm A", "HH:mm"]).minute();

                    if (rowIdx === startHour) {
                      const topPosition = (startMinute / 60) * 100;
                      return (
                        <div
                          className={styles.time_indicator_container}
                          style={{
                            top: `${topPosition}%`,
                          }}
                        >
                          <div className={styles.time_indicator_circle} />
                          <div className={styles.time_indicator_line} />
                        </div>
                      );
                    }
                  })()}
              </td>
              {officeSchedulerList?.map((scheduler, colIdx) => {
                const isLast = colIdx === officeSchedulerList.length - 1;
                const cellStyle = {
                  position: "relative",
                  height: "100%",
                  borderLeft: "1px solid #ddd",
                  borderRight: "1px solid #ddd",
                  overflow: "hidden",
                };
                if (selectedHourIdx === rowIdx) {
                  cellStyle.borderTop = "2px solid #a9cf3d";
                  cellStyle.borderBottom = "2px solid #a9cf3d";
                  if (isLast) {
                    cellStyle.borderRight = "2px solid #a9cf3d";
                  }
                }
                const allEvents = getAllStaffEvents(scheduler);
                const { timeEvents } = categorizeEvents(allEvents);
                const filteredTimeEvents = filterEventsBySearch(
                  timeEvents,
                  scheduler.user,
                  searchValue,
                );

                return (
                  <td
                    key={colIdx}
                    className={`${styles.tableCell} ${
                      holidayList.length > 0
                        ? styles["light-red-bg"]
                        : styles["no-bg-theme"]
                    }`}
                    style={cellStyle}
                    onDragOver={(e) => {
                      handleDragOver(e, rowIdx);
                    }}
                    onDrop={(e) => {
                      handleDrop(e, rowIdx);
                    }}
                  >
                    {/* Drag preview - show ONLY in the original column where the event belongs */}
                    {isDragging &&
                      dragPreviewPosition &&
                      dragPreviewPosition.hourIndex === rowIdx &&
                      draggedEvent?.eventItem &&
                      draggedEvent?.originalColumnIndex === colIdx && (
                        <div
                          style={{
                            position: "absolute",
                            top: `${dragPreviewPosition.topPercent}%`,
                            left: "1%",
                            width: "98%",
                            height: `${dragPreviewPosition.heightPercent}%`,
                            backgroundColor: getEventColor(
                              draggedEvent.eventItem,
                              0,
                            ),
                            opacity: 0.3,
                            border: `2px dashed ${getEventBorderColor(
                              draggedEvent.eventItem,
                            )}`,
                            borderRadius: 4,
                            zIndex: 5,
                            pointerEvents: "none",
                          }}
                        />
                      )}
                    {/* Common availability slots - only show when showFreeSlots is true */}
                    {showFreeSlots &&
                      commonAvailabilitySlots.map((slot, index) => {
                        // Calculate the start and end of the current hour in minutes
                        const hourStart = rowIdx * 60;
                        const hourEnd = (rowIdx + 1) * 60;
                        // Check if the slot overlaps with the current hour cell
                        if (slot.start < hourEnd && slot.end > hourStart) {
                          if (scrollReferenceForFirst.current === null) {
                            scrollReferenceForFirst.current = rowIdx;
                          }

                          // Calculate the effective start and end within this hour
                          const effectiveStart = Math.max(
                            slot.start,
                            hourStart,
                          );
                          const effectiveEnd = Math.min(slot.end, hourEnd);
                          const top = ((effectiveStart - hourStart) / 60) * 100;
                          let height =
                            ((effectiveEnd - effectiveStart) / 60) * 100;

                          // Minimum height logic for available slot
                          let slotHeightPx =
                            (height / 100) * HOUR_CELL_HEIGHT_PX;
                          if (slotHeightPx < MIN_EVENT_HEIGHT_PX) {
                            slotHeightPx = MIN_EVENT_HEIGHT_PX;
                          }
                          const heightPercent =
                            (slotHeightPx / HOUR_CELL_HEIGHT_PX) * 100;

                          // Calculate effective start and end dates for the slot click handler
                          const hourCellStartMoment = moment(currentDate)
                            .startOf("day")
                            .add(rowIdx, "hours");
                          const slotStartMoment = moment(currentDate)
                            .startOf("day")
                            .add(slot.start, "minutes");
                          const hourCellEndMoment = moment(currentDate)
                            .startOf("day")
                            .add(rowIdx + 1, "hours");
                          const slotEndMoment = moment(currentDate)
                            .startOf("day")
                            .add(slot.end, "minutes");
                          const effectiveStartDate = moment
                            .max(hourCellStartMoment, slotStartMoment)
                            .toDate();
                          const effectiveEndDate = moment
                            .min(slotEndMoment, hourCellEndMoment)
                            .toDate();

                          return (
                            <div
                              ref={
                                scrollReferenceForFirst.current === rowIdx
                                  ? firstAvailabilitySlotRef
                                  : null
                              }
                              key={`availability-${index}`}
                              style={{
                                position: "absolute",
                                top: `${top}%`,
                                left: 2,
                                right: 2,
                                height: `${heightPercent}%`,
                                borderRadius: 6,
                                backgroundColor: "rgba(144, 238, 144, 0.3)",
                                border: "1px solid rgba(144, 238, 144, 0.5)",
                                zIndex: 1,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: "10px",
                                fontWeight: 600,
                                color: "#2D3245",
                                cursor: onFreeSlotClick ? "pointer" : "default",
                              }}
                              onClick={() => {
                                if (onFreeSlotClick) {
                                  onFreeSlotClick(
                                    effectiveStartDate,
                                    effectiveEndDate, // Use the actual end of the available slot
                                  );
                                }
                              }}
                            >
                              {t("availableSlot")}
                            </div>
                          );
                        }
                        return null;
                      })}

                    {Object.entries(
                      groupEventsByStartTime(filteredTimeEvents),
                    ).map(([startMinutesStr, group], idx) => {
                      const overlapPositions = calculateOverlapPositions(group);

                      return overlapPositions.map(
                        ({ event, widthFactor, leftOffsetFactor }, index) => {
                          // Calculate event position within the hour
                          const startMinutes = getTimeInMinutes(
                            event.startTime,
                          );
                          const endMinutes = getTimeInMinutes(event.endTime);
                          const hourStartMinutes = rowIdx * 60;
                          const hourEndMinutes = (rowIdx + 1) * 60;

                          // Check if event overlaps with this hour
                          if (
                            !(
                              startMinutes < hourEndMinutes &&
                              endMinutes > hourStartMinutes
                            )
                          ) {
                            return null;
                          }

                          // Calculate position within the hour cell as percentages
                          const eventStartInHour = Math.max(
                            startMinutes,
                            hourStartMinutes,
                          );
                          const eventEndInHour = Math.min(
                            endMinutes,
                            hourEndMinutes,
                          );

                          const top =
                            ((eventStartInHour - hourStartMinutes) / 60) * 100;
                          const height =
                            ((eventEndInHour - eventStartInHour) / 60) * 100;

                          const HOUR_CELL_HEIGHT_PX = 60;
                          const MIN_EVENT_HEIGHT_PX = 8;

                          // Calculate pixel values
                          let eventHeightPx =
                            (height / 100) * HOUR_CELL_HEIGHT_PX;

                          let topPx = (top / 100) * HOUR_CELL_HEIGHT_PX;
                          if (eventHeightPx < MIN_EVENT_HEIGHT_PX) {
                            // Adjust height to minimum
                            eventHeightPx = MIN_EVENT_HEIGHT_PX;
                            // Prevent overflow if event is at the bottom of the cell
                            if (eventHeightPx + topPx > HOUR_CELL_HEIGHT_PX) {
                              eventHeightPx = HOUR_CELL_HEIGHT_PX - topPx;
                            }
                          }
                          const heightPercent =
                            (eventHeightPx / HOUR_CELL_HEIGHT_PX) * 100;

                          const topPercent =
                            (topPx / HOUR_CELL_HEIGHT_PX) * 100;

                          // Check if this is the first hour of the event (for showing label)
                          const eventStartHour = Math.floor(startMinutes / 60);
                          const isFirstHourOfEvent = eventStartHour === rowIdx;

                          // Check if event continues to next hour (no bottom spacing)
                          const continuesNextHour = endMinutes > hourEndMinutes;

                          // Check if event continues from previous hour (no top spacing)
                          const continuesFromPrevHour =
                            startMinutes < hourStartMinutes;

                          // Get event colors based on type
                          const eventColor = getEventColor(event, index);
                          const borderColor = getEventBorderColor(event);

                          // Calculate width and position as percentages of the cell
                          const eventWidthPercent = widthFactor * 100 - 1; // Subtract 1% for spacing
                          const leftOffsetPercent = leftOffsetFactor * 100;
                          const createdByOthers =
                            event?.isShift &&
                            profile?.id !== event?.createdById;

                          const thisHoverKey = `time-${rowIdx}-${colIdx}-${idx}-${index}`;
                          const tooltipId = `tooltip-${rowIdx}-${colIdx}-${idx}-${index}-${
                            event?.id || index
                          }`;

                          let shouldNavigate = false;
                          let shouldShowPopup = false;

                          if (event.agendaType === constants.agendaType.EVENT) {
                            shouldNavigate =
                              currentUserId === event.createdById ||
                              (createdByOthers &&
                                canEditAndViewOthersData(event?.officeId));
                            shouldShowPopup = !shouldNavigate;
                          } else if (
                            event.agendaType ===
                              constants.agendaType.BUSY_SLOT ||
                            event.agendaType === constants.agendaType.BLOCKED
                          ) {
                            shouldNavigate =
                              currentUserId === event.createdById;
                            shouldShowPopup = !shouldNavigate;
                          } else if (
                            event.agendaType ===
                            constants.agendaType.APPOINTMENT
                          ) {
                            shouldShowPopup = true;
                          }

                          // Get office color from officeColourCodes
                          const staffAssignedColor = getOfficeColor(
                            scheduler.user,
                            selectedOwnerId,
                          );

                          const canDrag = canDragEvent(event);
                          const isDragged =
                            isDragging &&
                            draggedEvent?.eventItem?.id === event.id;

                          return (
                            <React.Fragment
                              key={`${event.id}-${index}-${rowIdx}`}
                            >
                              <div
                                id={tooltipId}
                                draggable={canDrag}
                                onDragStart={(e) => {
                                  if (canDrag) {
                                    handleDragStart(
                                      e,
                                      event,
                                      {
                                        event,
                                        scheduler,
                                      },
                                      colIdx,
                                    );
                                  }
                                }}
                                onDragEnd={handleDragEnd}
                                style={{
                                  position: "absolute",
                                  top: `${topPercent}%`,
                                  left: `${leftOffsetPercent}%`,
                                  width: `${eventWidthPercent}%`,
                                  height: `${heightPercent}%`,
                                  borderRadius:
                                    continuesFromPrevHour || continuesNextHour
                                      ? 0
                                      : 6,
                                  borderTopLeftRadius: continuesFromPrevHour
                                    ? 0
                                    : 6,
                                  borderTopRightRadius: continuesFromPrevHour
                                    ? 0
                                    : 6,
                                  borderBottomLeftRadius: continuesNextHour
                                    ? 0
                                    : 6,
                                  borderBottomRightRadius: continuesNextHour
                                    ? 0
                                    : 6,
                                  zIndex: isDragged ? 10 : 2,
                                  overflow: "hidden",
                                  cursor: canDrag
                                    ? "grab"
                                    : shouldNavigate || shouldShowPopup
                                      ? "pointer"
                                      : "default",
                                  opacity: isDragged ? 0.5 : 1,
                                  borderLeft: "1px solid rgba(0, 0, 0, 0.3)",
                                  borderRight: "1px solid rgba(0, 0, 0, 0.3)",
                                  borderTop: continuesFromPrevHour
                                    ? "none"
                                    : "1px solid rgba(0, 0, 0, 0.3)",
                                  borderBottom: continuesNextHour
                                    ? "none"
                                    : "1px solid rgba(0, 0, 0, 0.3)",
                                }}
                                onMouseEnter={() => {
                                  if (!isDragging) {
                                    toggleTooltip(tooltipId);
                                  }
                                }}
                                onMouseLeave={() => {
                                  if (!isDragging) {
                                    toggleTooltip(tooltipId);
                                  }
                                }}
                                onClick={(e) => {
                                  if (isDragging) {
                                    e.preventDefault();
                                    return;
                                  }
                                  if (shouldNavigate) {
                                    goToDetails(
                                      event.id,
                                      event.agendaType,
                                      true,
                                      currentDate,
                                    );
                                  } else if (shouldShowPopup) {
                                    // Call helper to handle positioning logic
                                    handlePopupClick(
                                      e,
                                      event,
                                      scheduler,
                                      thisHoverKey,
                                    );
                                  }
                                }}
                              >
                                {/* Background */}
                                <div
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    backgroundColor: eventColor,
                                    opacity: 0.5,
                                  }}
                                />
                                {/* Content - only show in first hour of event */}
                                {isFirstHourOfEvent && (
                                  <div className={styles.first_hour_event}>
                                    <div
                                      style={{
                                        fontSize: 10,
                                        color: "#2D3245",
                                        opacity: 1,
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        width: "100%",
                                        paddingLeft: "10px",
                                      }}
                                    >
                                      {getEventDisplayText(
                                        event,
                                        scheduler?.user,
                                      )}
                                    </div>
                                  </div>
                                )}
                              </div>
                              <Tooltip
                                placement="top"
                                isOpen={openTooltipId === tooltipId}
                                target={tooltipId}
                                autohide={false}
                                toggle={() => toggleTooltip(tooltipId)}
                                className="weekly_list_tooltip_style"
                              >
                                <div
                                  className={
                                    staffAvailabilityStyles.tooltip_content
                                  }
                                >
                                  <div
                                    className={
                                      staffAvailabilityStyles.image_border
                                    }
                                    style={{
                                      border: `2px solid ${staffAssignedColor}`,
                                    }}
                                  >
                                    <img
                                      src={
                                        scheduler.user?.profilePic ||
                                        defautUserImage
                                      }
                                      onError={(e) => {
                                        e.currentTarget.src = defautUserImage;
                                      }}
                                      alt={event?.title || ""}
                                      className={
                                        staffAvailabilityStyles.tooltip_image
                                      }
                                    />
                                  </div>
                                  <div>
                                    <p
                                      className={
                                        staffAvailabilityStyles.staff_name
                                      }
                                    >
                                      {scheduler.user?.fullName}
                                    </p>
                                    {renderOfficeNameOrEnterprise(event, t) && (
                                      <div
                                        className={staffAvailabilityStyles.chip}
                                        style={{
                                          backgroundColor: staffAssignedColor,
                                          color: "#FFFFFF",
                                        }}
                                      >
                                        {renderOfficeNameOrEnterprise(event, t)}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </Tooltip>
                              {/* Removed inline popup rendering here */}
                            </React.Fragment>
                          );
                        },
                      );
                    })}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>

      {/* RENDER POPUP OUTSIDE TABLE but INSIDE RELATIVE CONTAINER */}
      {clickedEventData && (
        <div
          ref={popupRef}
          style={{
            position: "absolute",
            top: clickedEventData.top,
            left: clickedEventData.left,
            zIndex: 1050,
            width: POPUP_WIDTH, // Fixed width ensures calculation matches reality
            pointerEvents: "auto",
          }}
        >
          {getPopupView(
            clickedEventData.event,
            clickedEventData.bgColor,
            clickedEventData.tagColor,
            currentDate,
            clickedEventData.staffName,
          )}
        </div>
      )}

      {/* Edit Options Modal for recurring events */}
      {editModalConfirmation && pendingDragUpdate && (
        <EditOptionsModal
          isOpen={editModalConfirmation}
          closeStepOneModal={() => {
            setEditModalConfirmation(false);
            setPendingDragUpdate(null);
            setIsDragging(false);
            setDraggedEvent(null);
            setDragPreviewPosition(null);
          }}
          loader={isDragDropLoading}
          eventKey={
            pendingDragUpdate.isBusySlot
              ? {
                  eventOrShift: t("accountOwner.busySlot").toLowerCase(),
                }
              : {
                  eventOrShift: t(
                    `accountOwner.${
                      pendingDragUpdate.eventData?.isShift ? "shift" : "event"
                    }Tab`,
                  ).toLowerCase(),
                }
          }
          eventOrShiftTab={
            pendingDragUpdate.isBusySlot
              ? false
              : pendingDragUpdate.eventData?.isShift || false
          }
          busySlots={pendingDragUpdate.isBusySlot || false}
          repeatedOptionChanged={pendingDragUpdate.anyChangedForDate || false}
          handleConfirm={async (editType) => {
            try {
              setIsDragDropLoading(true);
              if (pendingDragUpdate.isBusySlot) {
                await performBusySlotUpdate(
                  pendingDragUpdate.busySlotData,
                  pendingDragUpdate.newDateTime,
                  editType,
                  pendingDragUpdate.officeDetails,
                  pendingDragUpdate.officeIds,
                  pendingDragUpdate.busySlotEmployeeView,
                  pendingDragUpdate.isAllDayBusy,
                  pendingDragUpdate.repeatedType,
                  pendingDragUpdate.repeatedEndDate,
                  pendingDragUpdate.originalRequestedDate,
                  pendingDragUpdate.UpdateFlags,
                );
              } else {
                await performEventUpdate(
                  pendingDragUpdate.eventData,
                  pendingDragUpdate.newDateTime,
                  editType,
                  pendingDragUpdate.originalRequestedDate,
                );
              }
            } catch (error) {
              // Error already shown in update functions
            } finally {
              setIsDragDropLoading(false);
              setIsDragging(false);
              setDraggedEvent(null);
              setDragPreviewPosition(null);
              setEditModalConfirmation(false);
              setPendingDragUpdate(null);
            }
          }}
        />
      )}
      {isDragDropLoading && <Loader />}
    </div>
  );
}

export default withTranslation()(DailyListView);